import React from 'react';
import { Button, Card } from '../components/components';
import { PageContainer } from '../layout/layouts';
import { theme } from '../styles/theme';

export const NotFound: React.FC = () => {
  return (
    <PageContainer>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        padding: theme.spacing.lg
      }}>
        <Card style={{ textAlign: 'center', maxWidth: '480px', padding: theme.spacing.xl }}>
          <span style={{ fontSize: '72px', display: 'block', marginBottom: theme.spacing.md }}>🔍</span>
          <h1 style={{ fontSize: '32px', fontWeight: theme.typography.fontWeight.bold, color: theme.colors.primary, margin: 0 }}>
            Page Not Found
          </h1>
          <p style={{ color: theme.colors.textSecondary, marginTop: theme.spacing.md, marginBottom: theme.spacing.lg }}>
            The requested page does not exist or has been moved. Verify the URL or return to the main dashboard.
          </p>
          <Button fullWidth onClick={() => window.location.href = '/'}>
            Return to Home
          </Button>
        </Card>
      </div>
    </PageContainer>
  );
};

export default NotFound;
